<template>
    <div id="aboutlanyve">
        <view1/>
        <view2/> 
        <view3/>
        <view4/>
        <view5/>
        <view6/>
        <view7/>
        <view8/>
    </div>
</template>
<script>
export default {
    name: 'aboutlanyve',
    components: {
        view1: () => import('@/views/aboutview/view1.vue'),
        view2: () => import('@/views/aboutview/view2.vue'),
        view3: () => import('@/views/aboutview/view3.vue'),
        view4: () => import('@/views/aboutview/view4.vue'),
        view5: () => import('@/views/aboutview/view5.vue'),
        view6: () => import('@/views/aboutview/view6.vue'),
        view7: () => import('@/views/aboutview/view7.vue'),
        view8: () => import('@/views/aboutview/view8.vue')
    }
}
</script>
<style scoped> 
</style>